import { NativeSyntheticEvent, TextInputKeyPressEventData } from 'react-native';

export function submitOnEnter(callback: () => void) {
  return (key: NativeSyntheticEvent<TextInputKeyPressEventData>) => {
    key.persist();
    key.nativeEvent.key === 'Enter' && callback();
  };
}
